import { PAGE_SIZE_OPTIONS } from '../../shared/constants'
import { COMPONENTS_PAGINATION_TEXTS as T } from '../../shared/texts'

// Footer for list views: page info on the left, numbered page navigation on the
// right. Always renders the footer bar; the page nav appears only with >1 page.
interface Props {
    page: number
    pageCount: number
    onPage: (page: number) => void
    pageSize: number
    onPageSize: (n: number) => void
}

// Page numbers to show: first, last, and a window around the current page, with
// ellipsis gaps (e.g. 1 … 4 5 6 … 20).
function pageItems(page: number, pageCount: number): (number | '…')[] {
    const items: (number | '…')[] = []
    const left = Math.max(2, page - 1)
    const right = Math.min(pageCount - 1, page + 1)
    items.push(1)
    if (left > 2) items.push('…')
    for (let p = left; p <= right; p++) items.push(p)
    if (right < pageCount - 1) items.push('…')
    if (pageCount > 1) items.push(pageCount)
    return items
}

export default function Pagination({ page, pageCount, onPage, pageSize, onPageSize }: Props) {
    // Always shown; with a single page the page controls are simply disabled.
    return (
        <div className="list-footer">
            <label className="page-size">
                {T.rowsPerPage}
                <select value={pageSize} onChange={(e) => onPageSize(Number(e.target.value))}>
                    {PAGE_SIZE_OPTIONS.map((n) => <option key={n} value={n}>{n}</option>)}
                </select>
            </label>
            <nav className="pager" aria-label={T.navAria}>
                <button className="secondary" disabled={page <= 1} onClick={() => onPage(page - 1)} aria-label={T.previous}>‹</button>
                {pageItems(page, pageCount).map((p, i) => (
                    p === '…'
                        ? <span key={`e${i}`} className="pager-ellipsis">…</span>
                        : <button key={p} className={`pager-page ${p === page ? 'active' : ''}`} disabled={p === page} onClick={() => onPage(p)} aria-current={p === page ? 'page' : undefined}>{p}</button>
                ))}
                <button className="secondary" disabled={page >= pageCount} onClick={() => onPage(page + 1)} aria-label={T.next}>›</button>
            </nav>
        </div>
    )
}
